import {FieldConfig} from '../../dynamic-field/field.config';
import {ComponentType} from '@angular/cdk/overlay';
import {IconConfig} from '../../models/icon.config';

export interface ButtonFieldConfig extends FieldConfig<string> {
    click?: () => {};
    customContent?: ComponentType<any>;
    buttonIcon?: string | IconConfig;
    buttonClass?: string;
}
